module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-charging-4b8d3b95f29663e6f4f85f68ab9eda8b.svg";